import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/logo-probus.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "pay-by-card"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pay-by-card--logo-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pay-by-card--secure-text" }, "Secure Payment Portal", -1)
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "pay-by-card--agree-text" }, [
  /*#__PURE__*/_createTextVNode(" By entering the PIN number or clicking “Pay Now” you accept our "),
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "“Terms & Conditions”"),
  /*#__PURE__*/_createTextVNode(" of use. Our cancellation policy is 4 hours prior to travel full payment. Card payments Incur a 3.5% administration fee. ")
], -1)
const _hoisted_7 = { class: "pay-by-card--price" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "pay-by-card--price-text" }, "Total Amount due", -1)
const _hoisted_9 = { class: "pay-by-card--price-amount" }
const _hoisted_10 = ["disabled"]

import { useRouter, useRoute } from 'vue-router'
import { formatCurrency } from "@/mixins/numbro";
import { useBookNowPayByCard, useBookNow } from '@/store/book-now'
import { onMounted, ref, reactive, computed } from 'vue';
import { Booking } from "@/models/book-now";
import { loadStripe } from "@stripe/stripe-js";
import type { Stripe, StripeCardNumberElement } from "@stripe/stripe-js";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookPayment',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const { resetForm } = useBookNow()
const { getBooking, createPaymentIntent, error, isPending } = useBookNowPayByCard(route.params.id as unknown as number, route.params.hash as string)



const booking = ref<Booking>()
const cardError = ref()
const cardErrors = reactive<{
  card: string | null;
  expiry: string | null;
  cvc: string | null;
}>({
  card: '',
  expiry: '',
  cvc: '',
})

const cardNumberDiv = ref<HTMLDivElement>()
const cardExpiryDiv = ref<HTMLDivElement>()
const cardCvcDiv = ref<HTMLDivElement>()

const isCardComplete = computed(() => {
  return (
    cardErrors.card === null &&
    cardErrors.expiry === null &&
    cardErrors.cvc === null
  )
})

let stripe: Stripe | null  = null
let cardNumber: StripeCardNumberElement
const setupStripe = async () => {
  stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLISH_KEY);
  if (!stripe || !cardNumberDiv.value || !cardExpiryDiv.value || !cardCvcDiv.value) {
    return;
  }

  const cardFormStyle = {
    base: {
      fontFamily: "Poppins, sans-serif",
      fontWeight: 400,
      letterSpacing: "1px",
      color: "#0f1419",
      fontSize: "14px",
    },
  };

  const elements = stripe.elements();
  cardNumber = elements.create('cardNumber', {
    style: cardFormStyle,
    placeholder: "CARD NUMBER",
  });

  const cardExpiry = elements.create('cardExpiry', {
    style: cardFormStyle,
    placeholder: "EXPIRY DATE (MM/YY)",
  });

  const cardCvc = elements.create('cardCvc', {
    style: cardFormStyle,
    placeholder: "CVV/CVC",
  });

  cardNumber.mount(cardNumberDiv.value);
  cardExpiry.mount(cardExpiryDiv.value);
  cardCvc.mount(cardCvcDiv.value);

  cardNumber.on("change", ({ error }) => {
    cardErrors.card = null
    if (error) {
      cardErrors.card = error.message;
    }
  });

  cardExpiry.on("change", ({ error }) => {
    cardErrors.expiry = null
    if (error) {
      cardErrors.expiry = error.message;
    }
  });

  cardCvc.on("change", ({ error }) => {
    cardErrors.cvc = null
    if (error) {
      cardErrors.cvc = error.message;
    }
  });
}

const onSubmit = async () => {
  if (stripe && isCardComplete.value) {
    const { clientSecret } = await createPaymentIntent()
    const result = await stripe.confirmCardPayment(
      clientSecret,
      {
        payment_method: {
          card: cardNumber,
        },
      }
    );

    if (result.error) {
      cardError.value = result.error.message
    } else {
      if (result.paymentIntent.status === 'succeeded') {
        resetForm()
        
        router.push({
          name: 'book_payment_successful',
          query: { intentId: result.paymentIntent.id },
          params: {
            id: booking.value!.id,
            hash: booking.value!.hash,
          },
        })
      }
    }
  } else {
    cardError.value = 'Please complete all fields'
  }
}

onMounted(async () => {
  booking.value = await getBooking()
  setupStripe()
})

return (_ctx: any,_cache: any) => {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppHeaderProgressBar = _resolveComponent("AppHeaderProgressBar")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AppHeader, { "back-route-to": { name: 'book_summary' } }),
    _createVNode(_component_AppHeaderProgressBar, {
      from: 0,
      to: 100
    }),
    _createElementVNode("div", _hoisted_1, [
      (booking.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("form", {
              onSubmit: _withModifiers(onSubmit, ["prevent"]),
              class: "pay-by-card--form"
            }, [
              _createVNode(_component_Error, { error: _unref(error) }, null, 8, ["error"]),
              _createVNode(_component_Error, { error: cardError.value }, null, 8, ["error"]),
              _createElementVNode("div", {
                ref_key: "cardNumberDiv",
                ref: cardNumberDiv
              }, null, 512),
              _createVNode(_component_Error, {
                error: cardErrors.card
              }, null, 8, ["error"]),
              _createElementVNode("div", {
                ref_key: "cardExpiryDiv",
                ref: cardExpiryDiv
              }, null, 512),
              _createVNode(_component_Error, {
                error: cardErrors.expiry
              }, null, 8, ["error"]),
              _createElementVNode("div", {
                ref_key: "cardCvcDiv",
                ref: cardCvcDiv
              }, null, 512),
              _createVNode(_component_Error, {
                error: cardErrors.cvc
              }, null, 8, ["error"]),
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(booking.value.priceFormatted), 1)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-block pay-by-card--paynow-btn",
                disabled: _unref(isPending) || !_unref(isCardComplete)
              }, " pay now ", 8, _hoisted_10)
            ], 40, _hoisted_5)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})